import { motion } from 'framer-motion';

export const SkeletonCard = () => {
    return (
        <div className="relative w-full aspect-[11/17] min-w-[140px] max-w-[280px] rounded-[24px] overflow-hidden bg-zinc-900/50 border border-white/5 mx-auto">
            {/* Background Image Placeholder */}
            <div className="absolute inset-0 bg-white/5 animate-pulse" />
            
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />

            {/* Top Right Badge Placeholder */}
            <div className="absolute top-3 right-3 z-20">
                <div className="w-16 h-5 bg-white/10 rounded-full animate-pulse" />
            </div>

            {/* Bottom Content Area */}
            <div className="absolute inset-x-0 bottom-0 p-4 z-20 flex flex-col gap-3">
                {/* Title Line */}
                <div className="w-3/4 h-4 bg-white/10 rounded-md animate-pulse" />
                
                {/* Financial Matrix Placeholder */}
                <div className="w-full bg-blue-500/10 border border-blue-500/20 backdrop-blur-md rounded-xl p-3 flex justify-between items-center">
                   <div className="flex flex-col gap-1 w-1/2">
                       <div className="w-1/2 h-2 bg-blue-400/20 rounded-sm animate-pulse" />
                       <div className="w-3/4 h-3 bg-blue-400/30 rounded-sm animate-pulse" />
                   </div>
                   <div className="w-8 h-8 rounded-full bg-blue-400/20 animate-pulse" />
                </div>

                {/* Specs Grid Placeholder */}
                <div className="grid grid-cols-2 gap-2 mt-2">
                    <div className="bg-white/5 h-10 rounded-xl animate-pulse" />
                    <div className="bg-white/5 h-10 rounded-xl animate-pulse" />
                </div>
            </div>
        </div>
    );
};
